import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalComponent } from './ui-kit/organisms/modal/modal.component';
import { ModalMessageService } from './services/modal-message.service';
import { CommonModule } from '@angular/common';
import { IframeResizeService } from './services/iframe-resize.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ModalComponent
  ],
  providers: [
    ModalMessageService
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'restitucion';
  viewModal: boolean = false;
  constructor(
    public modalMessageService: ModalMessageService,
    private readonly iframeResizeService: IframeResizeService,
  ){}

  ngOnInit(): void {
    this.modalMessageService.viewModal$.subscribe((isVisible) => {
      this.viewModal = isVisible;
      // console.log('this.viewModal', this.viewModal);
    });

    this.iframeResizeService.iniciar();
  }
}
